import React, { useState } from "react";
// import "./PuttingSplits.css";
import { graphql, useLazyLoadQuery } from "react-relay";
import PGAModelBuilderOutput from "../../PGAModelBuilderPage/PGAModelBuilderOutput";
import Button from "../../../../../Button";
import DraftkingsInfoOverlay from "../../../../../DraftKingsInfoOverlay";

const QUERY = graphql`
  query FieldOverviewQuery($eventId: ID!) {
    whoAmI {
      username
    }

    pgaTourGetDefaultModelForEvent(eventId: $eventId) {
      id
    }

    pgaTourEvent(eventId: $eventId) {
      id
      tournament {
        officialName
      }
    }
  }
`;

export default function FieldOverview({ eventId }) {
  const [viewRanks, setViewRanks] = useState(false);
  const [selectedDkPlayerId, setSelectedDkPlayerId] = useState(undefined);

  const data = useLazyLoadQuery(QUERY, { eventId });

  const modelID = data.pgaTourGetDefaultModelForEvent?.id;

  if (!modelID) {
    return;
  }

  function showDKPlayerInfo(playerId) {
    if (playerId) {
      setSelectedDkPlayerId(playerId);
    }
  }

  function hideDKPlayerInfo() {
    setSelectedDkPlayerId(undefined);
  }

  return (
    <div style={{ width: "100%", padding: "10px" }}>
      <DraftkingsInfoOverlay
        show={selectedDkPlayerId !== undefined}
        playerId={selectedDkPlayerId}
        close={hideDKPlayerInfo}
      />
      <div>
        <h3>{data.pgaTourEvent.tournament.officialName}</h3>
        <p>
          Below output includes up to <strong>24 most recent rounds</strong>{" "}
          each player in field has played at ANY course.
        </p>
        <hr />
      </div>
      <Button href="/tools/pga-model">Model Builder</Button>
      <br />
      <PGAModelBuilderOutput
        modelID={modelID}
        viewRanks={viewRanks}
        setViewRanks={setViewRanks}
        showDKPlayerInfo={showDKPlayerInfo}
      />
    </div>
  );
}
